export const API_URL = `${process.env.API}/ratingreview`;
export const API_URL_SUFFIX = `/ratingreview`;
export const JEST_DOMAIN = `${process.env.API}`;
export const PERSIST_KEY = 'rating-review';
